import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { TaskSummary } from '@/components/features/tasks/quotation/TaskSummary';
import { TaskProgress } from '@/components/features/tasks/quotation/TaskProgress';
import { TaskFiles } from '@/components/features/tasks/quotation/TaskFiles';
import { Comments } from '@/components/features/tasks/quotation/Comments';
import { Activities } from '@/components/features/tasks/quotation/Activities';
import { useCurrentWorkspace } from '@/providers/WorkspaceProvider';
import { ToDoList } from '@/components/features/tasks/quotation/ToDoList';
import { ProjectInfo } from '@/components/features/tasks/quotation/ProjectInfo';

export const ApprovalQuotationTask = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  const { _w_ } = useCurrentWorkspace();
  useEffect(() => setTitle('承認待ち一覧 - 申請タスク（見積）詳細'), []);
  useEffect(() => setBreadcrumbs([{ label: `Approval`, path: `/w/${_w_!.identifier}/approval` }]), []);

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="row mb-4">
          <div className="col-12 col-lg-7">
            <ToDoList />

            <TaskFiles />

            <Comments />
          </div>
          <div className="col-12 col-lg-5">
            <TaskSummary />

            <TaskProgress />

            <ProjectInfo />

            <Activities />
          </div>
        </div>
      </div>
    </WorkspaceLayout>
  );
};
